import { instanceAPIPrivate } from 'config/axiosconfig';
import { getUserSuccess, getUserError, getUserPending } from 'slices/userSlice';

const axiosConfig = {
  withCredentials: true,
};

export const userService = async (dispatch) => {
  dispatch(getUserPending());
  await instanceAPIPrivate.get('/get-personal-data', axiosConfig)
    .then((resp) => {
      const res = resp.data;
      dispatch(getUserSuccess(res));
    })
    .catch((err) => {
      const { status } = err.response.data;
      if (status === 403) {
        dispatch(getUserError());
      }
    });
};
